import React from 'react'
import { CircularProgress, makeStyles } from '@material-ui/core'
import StyledSVG from './StyledSVG'

const useStyles = makeStyles(theme => ({
  tag_detail_wrapper: {
    paddingBottom: 20,
    display: 'flex',
    flexWrap: 'wrap',
    columnGap: 24,
    rowGap: 21,
    overflow: 'auto'
  },
  tag_detail: {
    cursor: 'pointer',
    width: 530,
    minHeight: 170,
    borderRadius: 24,
    backgroundColor: '#F5F6F7',
    padding: 32,
    display: 'flex',
    alignItems: 'flex-start',
    gap: 32,
    overflow: 'hidden'
  },
  tag_detail_left_column: {
    height: 60,
    width: 60,
    backgroundColor: 'white',
    borderRadius: 16,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  tag_detail_right_column: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    width: '100%'
  },
  tag_name: {
    color: '#386093',
    margin: 0,
    fontWeight: 600,
    fontSize: 24
  },
  answer: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    '& .label': {
      margin: 0,
      fontSize: 16,
      fontWeight: 500
    }
  },
  answers_wrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: 18
  },
  total_amount: {
    backgroundColor: '#868E96 !important'
  },
  amount: {
    width: 50,
    height: 50,
    backgroundColor: '#00ACDB',
    borderRadius: 56,
    color: 'white',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& .total': {
      fontWeight: 600,
      fontSize: 18,
      margin: 0
    }
  }
}))

const TagValuesComponent = ({ tagValue, classes }) => {
  if (tagValue != null && typeof tagValue === 'object') {
    const tagsAnswers = Object.entries(tagValue).map(item => ({
      [item[0]]: item[1]
    }))
    const totalAnswers = tagsAnswers.reduce((acc, obj) => {
      const valor = Object.values(obj)[0]
      return acc + valor
    }, 0)
    return (
      <div className={classes.answers_wrapper}>
        <div className={classes.answer}>
          <p className='label'>Total</p>
          <div className={`${classes.amount} ${classes.total_amount}`}>
            <p className='total'>{totalAnswers}</p>
          </div>
        </div>
        {tagsAnswers.map((answer, index) => {
          return (
            Object.keys(answer)[0] && (
              <div key={index} className={classes.answer}>
                <p className='label'>{Object.keys(answer)[0]}</p>
                <div className={classes.amount}>
                  <p className='total'>{Object.values(answer)[0]}</p>
                </div>
              </div>
            )
          )
        })}
      </div>
    )
  } else {
    return (
      <div className={classes.answer}>
        <p className='label'>Total de registros</p>
        <div className={classes.amount}>
          <p className='total'>{tagValue || '00'}</p>
        </div>
      </div>
    )
  }
}

const ReportsInfos = ({ tags, setSelectedTag, tagIconSelect }) => {
  const classes = useStyles()

  const handleClickTag = tag => {
    setSelectedTag?.(tag)
  }

  if (tags.length > 0) {
    return (
      <div className={classes.tag_detail_wrapper}>
        {tags
          .filter(item => {
            return !Object.keys(item)[0].includes('_')
          })
          .map((tag, index) => {
            const tagName = Object.keys(tag)[0]
            const tagValue = Object.values(tag)[0]
            const tagIcon = tagIconSelect(tagName)
            if (tagName) {
              return (
                <div
                  onClick={() => handleClickTag(tagName)}
                  key={index}
                  className={classes.tag_detail}
                >
                  <div className={classes.tag_detail_left_column}>
                    <StyledSVG src={tagIcon} width={40} height={40} />
                  </div>
                  <div className={classes.tag_detail_right_column}>
                    <h1 className={classes.tag_name}>{tagName}</h1>
                    <TagValuesComponent tagValue={tagValue} classes={classes} />
                  </div>
                </div>
              )
            }
          })}
      </div>
    )
  }
  return <CircularProgress />
}

export default ReportsInfos
